import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenMessage } from '../models/open-message/open-message.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OpenMessageService extends RequestService<OpenMessage> {
  static PATH = '/open/message';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OpenMessageService.PATH, globalService.debugUrl);
  }
}
